import React from "react"
import PropTypes from "prop-types"
import ItemNameValueShape from "../../state/shapes/ItemNameValueShape"
import Widget from "../layout/widget/Widget"
import GaugeChart from "../charts/generic/GaugeChart"
import { CHARTS } from "../../constants"

function LabourTurnover({ exportEndpoint, appliedFilters, data, subtitleKey, sampleSize }) {
  const stopsValues = [
    [0.15, CHARTS.trafficLightColours.green],
    [0.4, CHARTS.trafficLightColours.amber],
    [0.7, CHARTS.trafficLightColours.red]
  ]

  const titleKey = "Widgets.LabourTurnover.Title"
  return (
    <Widget
      columns={1}
      helpKey="Widgets.LabourTurnover.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      titleKey={titleKey}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <GaugeChart data={data[0]} stopsValues={stopsValues} titleKey={titleKey} subtitleKey={subtitleKey}/>
    </Widget>
  )
}

LabourTurnover.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameValueShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string
}

export default LabourTurnover



// WEBPACK FOOTER //
// ./src/components/widgets/LabourTurnover.jsx